// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_gl-0";
export var fulfillmentPanelBody = "_gl-1";